import React, { Component } from "react";
import I18n from "i18n-js";

import TeamStageIcon from "../../assets/images/onboarding/team-stage.svg";

const Sections = () => ({
  team_stage: {
    id: "team-stage",
    icon: TeamStageIcon,
    title: I18n.t("team_stage.team_stage"),
    stepCount: 8
  },
});

export default class Status extends Component {
  changeSectionStyle = (step, section) => {
    switch (section) {
      case "team-stage":
        return this.handleSectionClass(step, 1, 8, 9);
      default:
        return "inactive-section";
    }
  };

  handleSectionClass = (step, activeStart, activeEnd, finishedStep) => {
    if (step >= activeStart && step <= activeEnd) {
      return "active-section";
    } else if (step >= finishedStep) {
      return "finished-section";
    } else {
      return "inactive-section";
    }
  };

  showStatus = (step) => {                                                                                    
    return Object.entries(Sections()).map(([_, value], index) => {
      const sectionStyle = this.changeSectionStyle(step, value.id);

      return (
        <div
          key={index}
          className={`status-item ${sectionStyle}`}
        >
          <div className="status-title">
            <img
              className="icon"
              src={value.icon}
              alt="icon"
            />
            <h6>{value.title}</h6>
          </div>
          <div className="status-count">
            <h6>{value.stepCount}</h6>
          </div>
        </div>
      );
    });
  };

  render() {
    const step = this.props.currentStep;

    return <div className="status-section">{this.showStatus(step)}</div>;
  }
}
